import React from 'react';

import Home from './Home';

import './home.less';

const HomePiracy = ({ context }) => (
  <Home
    context={context}
    dashboard="Frontofficecopyrightreport"
    translation="home"
  />
);

export default HomePiracy;
